import { createContext, useContext } from 'react';

export const DialogScopeContext = createContext('main');

export const useDialogScope = () => {
  return useContext(DialogScopeContext);
};

/**
 * @returns {boolean} true if rendered inside a dialog, false otherwise
 */
export const useInDialog = () => {
  return useContext(DialogScopeContext) === 'dialog';
};